import React from 'react';
import './Pagination.css'; // Create this CSS file for pagination specific styles

interface PaginationProps {
    currentPage: number;
    totalPages: number;
    totalItems: number;
    itemsPerPage: number;
    onPageChange: (page: number) => void;
    onPreviousPage: () => void;
    onNextPage: () => void;
}

const Pagination: React.FC<PaginationProps> = ({
    currentPage,
    totalPages,
    totalItems,
    itemsPerPage,
    onPreviousPage,
    onNextPage,
}) => {
    const startIndex = (currentPage - 1) * itemsPerPage + 1;
    const endIndex = Math.min(totalItems, currentPage * itemsPerPage);

    return (
        <div className="">
            <div className="summary-pagination">
                <button className='summary-pagination-prev' onClick={onPreviousPage} disabled={currentPage === 1}>
                    Previous
                </button>
                <span>
                Showing {Math.min(totalItems, startIndex)} to {endIndex} of {totalItems} entries
               </span>
                <button className='summary-pagination-next"' onClick={onNextPage} disabled={currentPage === totalPages}>
                    Next
                </button>
            </div>
        </div>
    );
};

export default Pagination;